import { createTheme } from "@mui/material/styles";
import { theme } from "@ui/theme";
import { settingPageColors } from "@octopus-settings/constants/ui/colors";

export const settingsTheme = createTheme(theme, {
  shape: {
    borderRadius: 2,
  },
  typography: {
    h5: {
      fontSize: 20,
      lineHeight: "32px",
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: 20,
      lineHeight: "32px",
      fontWeight: 600,
    },
    body2: {
      fontSize: 14,
      lineHeight: "16px",
      fontWeight: 400,
    },
    body2medium: {
      fontSize: 14,
      lineHeight: "16px",
      fontWeight: 500,
    },
    body3: {
      fontSize: 12,
      lineHeight: "16px",
      fontWeight: 400,
    },
    body3semibold: {
      fontSize: 12,
      lineHeight: "16px",
      fontWeight: 600,
    },
  },
  palette: {
    text: {
      secondary: settingPageColors.textTertiary,
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h5: {
          fontSize: 20,
          lineHeight: "32px",
          fontWeight: 600,
        },
        subtitle1: {
          fontSize: 20,
          lineHeight: "32px",
          fontWeight: 600,
        },
        body2: {
          fontSize: 14,
          lineHeight: "16px",
          fontWeight: 400,
        },
        body2medium: {
          fontSize: 14,
          lineHeight: "16px",
          fontWeight: 500,
        },
        body3: {
          fontSize: 12,
          lineHeight: "16px",
          fontWeight: 400,
        },
        body3semibold: {
          fontSize: 12,
          lineHeight: "16px",
          fontWeight: 600,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          textDecoration: "none",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          color: theme.palette.common.black,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
  },
});

export default settingsTheme;
